<template>
  <v-menu
    v-model="editDialog"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="dateValue"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="dateValue"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        :clearable="clearable"
        :rules="rules"
        v-bind="attrs"
        @click.clear="onClear"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="dateValue"
      :rules="rules"
      @input="onInput"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'DatePick',
  props: {
    date: { type: String },
    label: { type: String },
    rules: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dateValue: this.date,
      editDialog: false,
    };
  },
  methods: {
    onInput() {
      console.log('input')
      this.$emit('update', this.dateValue);
      this.editDialog = false;
    },
    onClear() {
      this.$emit('clear');
      this.dateValue = null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>